import {
  UPDATE_AWARD_FAILURE,
  UPDATE_AWARD_REQUEST,
  UPDATE_AWARD_RESET,
  UPDATE_AWARD_SUCCESS,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const editAwardReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AWARD_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case UPDATE_AWARD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case UPDATE_AWARD_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.message,
        success: false,
      }

    case UPDATE_AWARD_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default editAwardReducer
